import type { ReactNode } from 'react';

import { cx } from '@mage-ui/styled-system/css';
import {
  radio,
  radioBody,
  radioDescription,
  radioError,
  radioIcon,
  radioInner,
  radioLabel,
  radioLabelWrapper,
  radioRoot,
} from '@mage-ui/styled-system/recipes';
import { Radio as RadioMantine } from '@mantine/core';

export type RadioProps = {
  label?: ReactNode;
  error?: ReactNode;
  description?: ReactNode;
  value?: string;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  classNames?: {
    root?: string;
    radio?: string;
    icon?: string;
    inner?: string;
    body?: string;
    labelWrapper?: string;
    label?: string;
    description?: string;
    error?: string;
  };
};

export const Radio = ({ classNames, ...props }: RadioProps): ReactNode => {
  return (
    <RadioMantine
      classNames={{
        root: classNames?.root ?? radioRoot(),
        radio: cx(classNames?.radio ?? radio(), 'peer'),
        icon: classNames?.icon ?? radioIcon(),
        inner: classNames?.inner ?? radioInner(),
        body: classNames?.body ?? radioBody(),
        labelWrapper: classNames?.labelWrapper ?? radioLabelWrapper(),
        label: classNames?.label ?? radioLabel(),
        description: classNames?.description ?? radioDescription(),
        error: classNames?.error ?? radioError(),
      }}
      {...props}
    />
  );
};

Radio.displayName = 'Radio';
